import React from 'react';
import { Backdrop, Fade, makeStyles, Modal } from '@material-ui/core';

export interface LinkModalProps {
  isOpen: boolean;
  href?: string;
  htmlContent?: string;
  onClose: () => void;
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iframe: {
    width: '100%',
    height: '100%',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1, 2, 1),
    width: '45%',
    height: '70%',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      height: '95%',
      padding: theme.spacing(1),
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: '100%',
      padding: theme.spacing(0.5),
    },
  },
}));

interface SafeIframeProps {
  href?: string;
  htmlContent?: string;
  className?: string;
}

const SafeIframe: React.FC<SafeIframeProps> = React.memo(({ href, htmlContent, className }) => {
  if (href) {
    return <iframe title="3D Form" src={href} className={className} />;
  }
  if (htmlContent) {
    return (
      <iframe
        title="3D Form"
        className={className}
        srcDoc={htmlContent}
      />
    );
  }
  return null;
});

const LinkModal: React.FC<LinkModalProps> = ({ onClose, isOpen, href, htmlContent, ...modalProps }) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={isOpen}
        onClose={onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={isOpen}>
          <div className={classes.paper}>
            <SafeIframe href={href} htmlContent={htmlContent} className={classes.iframe} />
          </div>
        </Fade>
      </Modal>
    </React.Fragment>
  );
};

export default LinkModal;
